var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.405,
    height: 26.405,
    viewBox: "0 0 26.405 26.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search-2",
    "data-name": "Search",
    d: "M26.082,24.565l-4.538-4.437h0l-.106-.162a1.069,1.069,0,0,0-1.5,0h0a10.711,10.711,0,0,1-13.887.449A10.138,10.138,0,0,1,3.8,7.011,10.662,10.662,0,0,1,17.1,3.092a10.221,10.221,0,0,1,5.7,12.391,1.028,1.028,0,0,0,.24,1.019,1.085,1.085,0,0,0,1.022.306,1.06,1.06,0,0,0,.782-.712h0a12.323,12.323,0,0,0-6.6-14.853A12.878,12.878,0,0,0,2.23,5.394a12.22,12.22,0,0,0,1.8,16.1,12.924,12.924,0,0,0,16.549.68L24.593,26.1a1.081,1.081,0,0,0,1.5,0,1.035,1.035,0,0,0,0-1.479h0Z",
    transform: "translate(0)",
    fill: "#fafbfb"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.0bc7ab6d340033a3b5edf2ef06840e4e.svg";
export { ForwardRef as ReactComponent };